class DuepaStickyAtc extends HTMLElement {
  connectedCallback() {
    this.controller?.abort(); this.observer?.disconnect(); this.mutations?.disconnect(); this.modalObserver?.disconnect();
    if (this.modalFrame) cancelAnimationFrame(this.modalFrame);
    this.controller = new AbortController();
    const {signal} = this.controller;
    const button = document.getElementById(this.dataset.buttonId), form = document.getElementById(this.dataset.formId), mirror = this.querySelector('button');
    if (!mirror) return;
    mirror.type = 'button';
    const associated = () => button?.isConnected && form?.isConnected && button.closest('form') === form && button.matches('[data-buy-button][type="submit"]');
    if (!associated() || !window.IntersectionObserver) {mirror.disabled = true; return;}
    const sync = () => {mirror.disabled = !associated() || button.disabled;}; sync();
    this.mutations = new MutationObserver(sync); this.mutations.observe(button, {attributes:true,attributeFilter:['disabled']});
    const renderedModal = element => {
      if (element.hidden || element.getAttribute('aria-hidden') === 'true') return false;
      if (!element.getClientRects().length) return false;
      const rect = element.getBoundingClientRect();
      if (rect.width <= 0 || rect.height <= 0 || rect.bottom <= 0 || rect.right <= 0 || rect.top >= innerHeight || rect.left >= innerWidth) return false;
      if (element.checkVisibility) return element.checkVisibility({checkOpacity:true,checkVisibilityCSS:true});
      const style = getComputedStyle(element);
      return style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) > 0;
    };
    const updateVisibility = () => {
      const modalOpen = [...document.querySelectorAll('dialog[open], [aria-modal="true"]')].some(renderedModal);
      const nextHidden = this.buyVisible !== false || modalOpen;
      if (this.hidden !== nextHidden) this.hidden = nextHidden;
    };
    const scheduleVisibility = () => {
      if (this.modalFrame) return;
      this.modalFrame = requestAnimationFrame(() => {this.modalFrame = 0; updateVisibility();});
    };
    this.modalObserver = new MutationObserver(records => {
      if (records.every(record => record.target === this)) return;
      scheduleVisibility();
    });
    const watchModals = () => {
      if (this.buyVisible === false && !this.modalWatching) {
        this.modalObserver.observe(document.body, {subtree:true,childList:true,attributes:true,attributeFilter:['open','aria-modal','aria-hidden','hidden','style','class']});
        this.modalWatching = true;
      } else if (this.buyVisible !== false && this.modalWatching) {
        this.modalObserver.disconnect(); this.modalWatching = false;
      }
    };
    window.addEventListener('resize', scheduleVisibility, {signal});
    window.addEventListener('pageshow', scheduleVisibility, {signal});
    document.addEventListener('visibilitychange', scheduleVisibility, {signal});
    mirror.addEventListener('click', () => {
      sync();
      if (mirror.disabled || this.delegating) return;
      this.delegating = true;
      try {button.click();} finally {this.delegating = false; sync();}
    }, {signal});
    this.observer = new IntersectionObserver(entries => {this.buyVisible = entries[0].isIntersecting; watchModals(); updateVisibility();}, {threshold:0}); this.observer.observe(button);
    scheduleVisibility();
  }
  disconnectedCallback() {this.controller?.abort(); this.observer?.disconnect(); this.mutations?.disconnect(); this.modalObserver?.disconnect(); this.modalWatching = false; if (this.modalFrame) cancelAnimationFrame(this.modalFrame); this.modalFrame = 0;}
}
if (!customElements.get('duepa-sticky-atc')) customElements.define('duepa-sticky-atc', DuepaStickyAtc);
